import { loyaltyLinks } from "../../../components/lib/SidebarLinks";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import GiftCardTabs from "./tabs/gift-cards-tabs";
import VoucherTabs from "./tabs/voucher-tabs";
import PointsTabs from "./tabs/points";
import C2CGiftCardTabs from "./tabs/C2C-Gift-Card";
import { fetchLoyaltyTemplates } from "@/redux/slice/loyalty/templeteSlice";
import { EditGiftCardDialog } from "@/components/loyalty/template/gift-card-dialog";

function Templetas() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { templates, getLoading } = useSelector(
    (state) => state.loyalty.template,
  );
  const [selectedTab, setSelectedTab] = useState("gift_card");
  const [isTemplateDialogOpen, setIsTemplateDialogOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (user.restaurant_id) {
      dispatch(
        fetchLoyaltyTemplates({
          type: selectedTab,
          restaurant_id: user.restaurant_id,
          per_page: 10,
        }),
      );
    }
  }, [dispatch, selectedTab, user.restaurant_id]);

  const handleOpenCreate = () => {
    setSelectedTemplate(null);
    setIsTemplateDialogOpen(true);
  };

  const handleOpenEdit = (template) => {
    setSelectedTemplate(template || null);
    setIsTemplateDialogOpen(true);
  };

  const handleCloseModal = () => {
    setIsTemplateDialogOpen(false);
    setSelectedTemplate(null);
  };

  return (
    <Layout2
      pageName={{ title: "All Templates" }}
      paths={[{ name: "Loyalty", path: "/loyalty" }, { name: "Templates" }]}
      LeftBar={<LeftBar2 sidebarLinks={loyaltyLinks} />}
    >
      <div className="container flex flex-col gap-6 mt-6">
        <Tabs
          valueKey="loyalty-gift-card"
          value={selectedTab}
          defaultValue={'gift_card'}
          className="bg-transparent relative"
          onValueChange={(value) => setSelectedTab(value)}
        >
          <TabsList className="w-full flex justify-start">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="gift_card">
              Gift Cards
            </TabsTrigger>
            <TabsTrigger className="bg-transparent" value="voucher">
              Vouchers
            </TabsTrigger>
            <TabsTrigger className="bg-transparent" value="c2c_voucher">
              C2C Gift Cards
            </TabsTrigger>
            <TabsTrigger className="bg-transparent" value="point">
              Points
            </TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <GiftCardTabs
            templates={templates}
            getLoading={getLoading}
            onOpenCreate={handleOpenCreate}
            onOpenEdit={handleOpenEdit}
          />
          <VoucherTabs
            templates={templates}
            getLoading={getLoading}
            onOpenCreate={handleOpenCreate}
            onOpenEdit={handleOpenEdit}
          />
          <PointsTabs
            templates={templates}
            getLoading={getLoading}
            onOpenCreate={handleOpenCreate}
            onOpenEdit={handleOpenEdit}
          />
          <C2CGiftCardTabs
            templates={templates}
            getLoading={getLoading}
            onOpenCreate={handleOpenCreate}
            onOpenEdit={handleOpenEdit}
          />
        </Tabs>

        <EditGiftCardDialog
          isOpen={isTemplateDialogOpen}
          onClose={handleCloseModal}
          type={selectedTab}
          restaurantId={user?.restaurant_id}
          selectedTemplate={selectedTemplate}
        />
      </div>
    </Layout2>
  );
}

export default Templetas;
